import { render } from "./desktopU.vue?vue&type=template&id=73d0a9d0"
import script from "./desktopU.vue?vue&type=script&lang=js"
export * from "./desktopU.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__